import { ArrowUpRight } from "lucide-react";
import React from "react";
import { Prettify } from "../../utils/types";
import { BaseButton } from "./BaseButton";
import { BaseButtonProps } from "./types";

type ButtonTextProps = {
    /**
     * Defines the displayable text for label.
     */
    title: string;
    icon?: never;
};

type ButtonIconTextProps = {
    /**
     * Defines the displayable text for label.
     */
    title: string;
    /**
     * Defines if an `ArrowUpRight` icon should show up.
     */
    icon: boolean;
};

type ButtonIconProps = {
    title?: never;
    /**
     * Defines if an `ArrowUpRight` icon should show up.
     */
    icon: boolean;
};

type ButtonVariantProps = ButtonTextProps | ButtonIconTextProps | ButtonIconProps;

export type ExternalLinkButtonProps = Prettify<Omit<BaseButtonProps<"a">, "as" | "variant" | "disabled">> &
    ButtonVariantProps;

export const ExternalLinkButton = React.forwardRef<HTMLAnchorElement, ExternalLinkButtonProps>(
    ({ icon, ...props }, ref) => (
        <BaseButton
            {...props}
            as="a"
            variant="external"
            icon={undefined}
            endIcon={icon ? <ArrowUpRight /> : undefined}
            ref={ref}
        />
    )
);
